module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-wrapper pure-g",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "pure-menu"
  }, [_c('a', {
    staticClass: "pure-menu-heading custom-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("vue-readme")]), _vm._v(" "), _c('a', {
    staticClass: "custom-toggle",
    attrs: {
      "href": "#",
      "id": "toggle"
    }
  }, [_c('s', {
    staticClass: "bar"
  }), _c('s', {
    staticClass: "bar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-1-3",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "pure-menu pure-menu-horizontal custom-menu-3 custom-can-transform"
  }, [_c('ul', {
    staticClass: "pure-menu-list"
  }, [_c('li', {
    staticClass: "pure-menu-item"
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "pure-menu-item"
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', {
    staticClass: "pure-menu-item"
  }, [_c('a', {
    staticClass: "pure-menu-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13bbbc92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar.vue
// module id = 58
// module chunks = 0